import './number-of-installments.scss';
import React from 'react';
import { useTranslate } from 'shared/helper/translate';
import { Controls, validators } from 'shared/helper/form';
import { price } from '../helpers/price';
var notEmpty = validators.notEmpty;
var Select = Controls.Select;
var NumberOfInstallments = function NumberOfInstallments(_ref) {
  var _ref$convertNumberOfI = _ref.convertNumberOfInstallments,
    convertNumberOfInstallments = _ref$convertNumberOfI === void 0 ? false : _ref$convertNumberOfI,
    currency = _ref.currency,
    total = _ref.total;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement(Select, {
    label: "Number of installments",
    messages: {
      notEmpty: 'You must select a valid number of installments'
    },
    name: "allpagoCreditCard[numberOfInstallments]",
    validators: {
      notEmpty: notEmpty
    },
    options: new Array(6).fill(1).map(function (val, i) {
      return {
        label: t('%(installments)s x %(amount)s for total of %(cartTotal)s', {
          amount: price(currency, total / (i + 1), true, convertNumberOfInstallments),
          cartTotal: price(currency, total, true, convertNumberOfInstallments),
          installments: i + 1
        }),
        value: i + 1
      };
    })
  });
};
export default NumberOfInstallments;